<app-loading class="m-5" *ngIf="loading"></app-loading>

<div id="hojanormal" *ngIf="(registros > 0)">


    <div class="doNotPrint" style="text-align: left" class="col-lg-12">
    <h4>
        <i> &nbsp; Información detallada de liquidación Gasto COD [{{ codgas }}] </i> 
        <button mat-icon-button color="danger" (click)="print2()">
        <mat-icon aria-label="print">print</mat-icon>
        </button>
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        <img src="../../../../assets/img/newass.png" style="width: 200px; height: 80px; text-align: right;">
    </h4> 
    <hr>
    </div>

    <div id="print-section" class="col-lg-12">
    <h4 style="text-align:center"><b> MOTIVO: </b> {{ moti }}, <i> "{{ detmoti }}"</i></h4>
    <hr>
    <h5>&nbsp; <b>USUARIO:</b> {{ user }} </h5>
    <h5>&nbsp; <b>SECCIONAL/DELEGACIÓN:</b> {{ secc }} </h5>
    <hr>
    <h5 style="background-color: yellow; ">&nbsp;<b>GASTO COD:</b> {{ codgas }} <i>({{ est }})</i> </h5>
    <h5>&nbsp;<b>FECHA CARGA:</b> {{ feccarga | date:"dd/MM/yyyy" }} </h5>
    <div style="width: 600px">
        <hr>
    </div>
    
    <h5>&nbsp; <b> <i>Detalle del gasto</i> </b> </h5>

    <div id="grid" #TABLE>
        <div class="example-container mat-elevation-z8">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                
                <ng-container matColumnDef="COD_DETALLE">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> COD_DETALLE </th>
                    <td mat-cell *matCellDef="let element"> {{element.COD_DETALLE}} </td>
                </ng-container>
                
                <ng-container matColumnDef="FECHA_TICKET">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA_TICKET </th>
                    <td mat-cell *matCellDef="let element"> {{element.FECHA_TICKET | date:"dd/MM/yy"}} </td>
                </ng-container>
                <ng-container matColumnDef="DETALLE">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                    <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element">"{{(element.DETALLE !=='null') ? (element.DETALLE) : ('----')}}"</td>
                </ng-container>
                <ng-container matColumnDef="IMPORTE">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> IMPORTE </th>
                    <td style="font-weight: bold;" mat-cell *matCellDef="let element"> ${{element.IMPORTE}} </td>
                </ng-container>
                <ng-container matColumnDef="CATEGORIA">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> CATEGORIA </th>
                    <td mat-cell *matCellDef="let element"> {{ element.CATEGORIA }} </td>
                </ng-container>
                <ng-container matColumnDef="OBSERVACIONES">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> OBSERVACIONES </th>
                    <td mat-cell *matCellDef="let element"> {{ element.OBSERVACIONES }} </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row (click)="selectRow(row.COD_DETALLE,row.DETALLE,row.IMPORTE,row.FECHA_TICKET,row.IMAGEN)" data-toggle="modal" data-target="#exampleModal2" *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
            </table>
        </div>
        
        <mat-paginator hidden [pageSize]=500 [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>
        <div style="width: 600px; text-align:right;">
            <br>
            <hr>

            <h5 style="background-color: yellow; "><b>TOTAL GASTO:</b> {{ totgasto | currency:"$" }} </h5>
        </div>
    </div>

    <div class="doNotPrint">
    
    </div>
</div>